var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
function SvgCalendarV2(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "calendarV2_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#d9d9d9",
    d: "M0 0h32v32H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#calendarV2_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M6.667 29.333a2.57 2.57 0 01-1.884-.783A2.57 2.57 0 014 26.667V8q0-1.1.783-1.883a2.57 2.57 0 011.884-.784H8V2.667h2.667v2.666h10.666V2.667H24v2.666h1.333q1.1 0 1.884.784Q28 6.9 28 8v18.667q0 1.099-.783 1.883a2.57 2.57 0 01-1.884.783zm0-2.666h18.666V13.333H6.667zm0-16h18.666V8H6.667zm9.333 8a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.383-.95q0-.566.383-.95A1.3 1.3 0 0116 16q.566 0 .95.383.383.384.383.95 0 .567-.383.95a1.3 1.3 0 01-.95.384m-5.333 0a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.384-.95q0-.566.384-.95a1.3 1.3 0 01.95-.383q.566 0 .95.383.383.384.383.95 0 .567-.383.95a1.3 1.3 0 01-.95.384m10.666 0a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.383-.95q0-.566.383-.95a1.3 1.3 0 01.95-.383q.567 0 .95.383.384.384.384.95 0 .567-.384.95a1.3 1.3 0 01-.95.384M16 24a1.3 1.3 0 01-.95-.383 1.3 1.3 0 01-.383-.95q0-.567.383-.95a1.3 1.3 0 01.95-.384q.566 0 .95.384.383.383.383.95 0 .566-.383.95A1.3 1.3 0 0116 24m-5.333 0a1.3 1.3 0 01-.95-.383 1.3 1.3 0 01-.384-.95q0-.567.384-.95a1.3 1.3 0 01.95-.384q.566 0 .95.384.383.383.383.95 0 .566-.383.95a1.3 1.3 0 01-.95.383m10.666 0a1.3 1.3 0 01-.95-.383 1.3 1.3 0 01-.383-.95q0-.567.383-.95a1.3 1.3 0 01.95-.384q.567 0 .95.384.384.383.384.95 0 .566-.384.95a1.3 1.3 0 01-.95.383"
  }))));
}
export default SvgCalendarV2;